<script lang="ts">
    import {getCurrentLanguage, getLocalization} from 'core/svelte-context/context';
    import KpPluralizeText from 'shared/components/kp-pluralize-text/KpPluralizeText.svelte';

    export let totalElements: number;
    export let duration: number;

    const localize = getLocalization();
    const currentLanguage = getCurrentLanguage();
</script>

<div id="search-result-records-count-info" class="search-result-info">
    <span class="total-elements">
        <span class="total-elements-value">{totalElements.toLocaleString(currentLanguage)}</span>

        <span class="total-elements-info">
            <KpPluralizeText count="{totalElements}"
                             zeroCountText="{localize(/* @kp-localization vysledky.nalezenychZaznamu */ 'vysledky.nalezenychZaznamu')}"
                             oneCountText="{localize(/* @kp-localization vysledky.nalezenyZaznam */ 'vysledky.nalezenyZaznam')}"
                             twoThreeFourCountText="{localize(/* @kp-localization vysledky.nalezeneZaznamy */ 'vysledky.nalezeneZaznamy')}"
                             moreText="{localize(/* @kp-localization vysledky.nalezenychZaznamu */ 'vysledky.nalezenychZaznamu')}"/>
        </span>
    </span>

    <span class="elements-and-search-time-separator">,</span>

    <span class="search-time">
        <span class="search-time-info">
            {localize(/* @kp-localization vysledky.hledaniTrvalo */ 'vysledky.hledaniTrvalo')}
        </span>

        <span class="search-time-value">
            <span>{duration.toLocaleString(currentLanguage)}</span>
            <span>ms</span>
        </span>
    </span>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .search-result-info {
        margin-top: @spacing-sm;
        color: @themed-text-muted;
    }
</style>